export default __webpack_public_path__ + "static/media/img-logo-opsgenie.fb5204d5.svg";